import update from 'immutability-helper'
import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  GET_CAMPAIGN_GRAPHS,
  GET_CAMPAIGN_GRAPHS_SUCCESS,
  GET_CAMPAIGN_GRAPHS_FAILURE,
  CLEAR_CAMPAIGN_GRAPHS,
  SET_CAMPAIGNS_SUMMARY_FILTER,
  SET_CAMPAIGNS_SUMMARY_DATE_RANGE,
  SET_CAMPAIGNS_SUMMARY_SORT,
  FILTER,
  SORT,
  CLEAR_CAMPAIGNS_SUMMARY_FILTERS,
  LINE_ITEMS_SELECTION_CHANGE,
  CLEAR_LINE_ITEMS_SELECTION_CHANGE
} from '../actions/campaignsSummary'
import {
  campaignFiltersList,
  DATE_STATIC_PRESET,
  LIFETIME_DATE_PRESET
} from '../../constants/selectLists/listItemFiltersList'
import { INITIAL_GET_REDUCER } from '../../constants/reducer'
import { getCookie } from '../../helpers/common'

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  campaignGraphs: INITIAL_GET_REDUCER,
  selectedLineItems: {},
  filter: getCookie(FILTER) || campaignFiltersList[0].value,
  dateRange: { [DATE_STATIC_PRESET]: LIFETIME_DATE_PRESET },
  sort: getCookie(SORT) || {}
}

export default function campaignsSummary(state = initialState, action) {
  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS
    case GET_CAMPAIGN_GRAPHS:
      return update(state, {
        campaignGraphs: {
          $merge: {
            isLoading: true
          }
        }
      })
    case GET_CAMPAIGN_GRAPHS_SUCCESS:
      return update(state, {
        campaignGraphs: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.campaignGraphsData
          }
        }
      })
    case GET_CAMPAIGN_GRAPHS_FAILURE:
      return update(state, {
        campaignGraphs: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_CAMPAIGN_GRAPHS:
      return update(state, {
        campaignGraphs: {
          $set: initialState.campaignGraphs
        }
      })
    case SET_CAMPAIGNS_SUMMARY_FILTER:
      return update(state, {
        filter: { $set: action.filter }
      })
    case SET_CAMPAIGNS_SUMMARY_DATE_RANGE:
      return update(state, {
        dateRange: { $set: action.dateRange }
      })
    case SET_CAMPAIGNS_SUMMARY_SORT:
      return update(state, {
        sort: { $set: action.sort }
      })
    case CLEAR_CAMPAIGNS_SUMMARY_FILTERS:
      return update(state, {
        // back to initial values, set manually because cookie clearing can happen later
        filter: { $set: campaignFiltersList[0].value },
        dateRange: { $set: { [DATE_STATIC_PRESET]: LIFETIME_DATE_PRESET } },
        sort: { $set: {} }
      })
    case LINE_ITEMS_SELECTION_CHANGE:
      const newSelections = { ...state.selectedLineItems }
      if (state.selectedLineItems[action.lineItemId]) {
        delete newSelections[action.lineItemId]
      } else {
        newSelections[action.lineItemId] = true
      }

      return update(state, {
        selectedLineItems: { $set: newSelections }
      })
    case CLEAR_LINE_ITEMS_SELECTION_CHANGE:
      return update(state, {
        selectedLineItems: { $set: initialState.selectedLineItems }
      })
    default:
      return state
  }
}
